import React from "react";
import logo1 from '../asset/image/install.png';
const MainBanner = () => {
  return (
    <div className="main-banner wow fadeIn" id="top " data-wow-duration="1000ms" data-wow-delay="500ms">
      <div className="container mx-auto">
        <div className="lg:flex justify-between">
          <div className="lg:w-2/5 lg:order-1">
            <div className="left-content show-up header-text wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="1000ms">
              <div className="mb-8">
                <h2 className="text-4xl font-bold mb-4 text-white">Udemy Summary: Harness the Power of OpenAI</h2>
                <p className="text-white text-justify px-3">
                  Our advanced Udemy Summary: Harness the Power of OpenAI tool powered by ChatGPT generates concise and to the point summaries for your convenience.
                  <br />
                  Whether you're a student, a professional learning a new skill, or an information viewer looking to save time, our tools will enhance your learning experience on the Udemy platform.
                </p>
                <div>
                </div>
              </div>
              <div className="flex button1">
                <div className="white-button first-button scroll-to-section mr-4">
                  <a href="https://chromewebstore.google.com/detail/udemy-summary-harness-the/dcclmkicpmnakdmgehlbbcagfpkdpkdl" target='blank' className="text-white">
                    Add to browser <i className="fab fa-apple" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2 lg:order-2">
            <div className="right-image wow fadeInRight" data-wow-duration="1000ms" data-wow-delay="500ms">
            <img className="wow" src={logo1} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainBanner;
